<template>
  <div class="account-summary-vue">
    <Header>
      <template v-slot:title>
        <span v-if="whitelabel === 'Blackstone'"> My Trading Accounts </span>
        <span v-else>
          {{ $t("account-summary") }}
        </span>
      </template>
      <template v-slot:buttons>
        <span class="inline-flex rounded-md">
          <button
            v-if="
              whitelabel !== 'Blackstone' &&
              whitelabel !== 'OrbitInvest' &&
              whitelabel !== 'VCGMarkets'
            "
            class="relative inline-flex items-center pr-4 pl-1 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50"
            type="button"
            @click="showAddDemoAccountModal = true"
          >
            <svg
              class="h-5 w-0 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("add-a-new-demo-account") }}
            </span>
            <span class="md:hidden flex">
              <svg
                class="h-5 mr-2 text-gray-700 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
              </svg>
              {{ $t("demo") }}
            </span>
          </button>
        </span>
        <span
          v-if="
            get_profile.state !== 'Demo' &&
            whitelabel !== 'Blackstone' &&
            whitelabel !== 'OrbitInvest' &&
            whitelabel !== 'VCGMarkets'
          "
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <button
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            type="button"
            @click="showAddAccountModal = true"
          >
            <svg
              class="h-5 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-trading-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </button>
        </span>
        <!-- #BR#74 - Mbeng Atemson - Become a Broker Request  mu- 09/04/2025 -->
         <!-- #BR#88 - Mbeng Atemson - Become a Broker Request  vc- 16/05/2025 -->
        <!-- #BR#52 - Mbeng Atemson - Become a Broker Request  Sc- 26/07/2025-->
        <!-- #BR# - Mbeng Atemson - removed Become a Broker Request for vc - 23/04/2026-->
        <span
          v-if="
            (get_profile.state === 'Full' || get_profile.state === 'Inactive'|| get_profile.state === 'Dormant') && (whitelabel ==='ICMMU' || whitelabel === 'ICMSC')
          "
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <button
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            type="button"
            @click="showBecomeBrokerPopup = true"
          >
             <!-- ERR#48 mbeng 16/05/2025 add translation to broker button -->
            <span class="hidden md:flex">
              {{ $t("become-an-introducing-broker")}}
            </span>
            <span class="md:hidden">
              {{ $t("broker") }}
            </span>
          </button>
        </span>
        <span
          v-if="whitelabel === 'Blackstone'"
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <router-link
            class="relative bg-main-button-color inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-normal rounded-md text-white focus:outline-none focus:shadow-outline-indigo"
            to="/add-new-live-account"
            type="button"
          >
            <svg
              class="h-5 mr-2 text-white group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-trading-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </router-link>
        </span>
        <span
          v-if="whitelabel === 'Blackstone'"
          class="inline-flex rounded-md shadow-sm ms-3"
        >
          <router-link
            class="relative inline-flex items-center pr-4 pl-1 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50"
            to="/add-new-demo-account"
            type="button"
          >
            <svg
              class="h-5 mr-2 text-gray-700 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <span class="hidden md:flex">
              {{ $t("create-a-new-demo-account") }}
            </span>
            <span class="md:hidden">
              {{ $t("new") }}
            </span>
          </router-link>
        </span>
        <div
          class="flex gap-2 md:gap-4 flex-wrap justify-end"
          v-if="whitelabel === 'VCGMarkets'"
        >
          <LinkButton
            v-if="whitelabel === 'VCGMarkets' && get_profile.state === 'Demo'"
            to="/open-live-account"
            :button-text="$t('Complete registration')"
          />

          <LinkButton
            v-if="
              (get_profile.state === 'Limited' ||
                get_profile.state === 'Pending') &&
              whitelabel === 'VCGMarkets'
            "
            to="/upload-documents"
            :button-text="$t('Upload documents')"
          />
          <LinkButton
            v-if="whitelabel === 'VCGMarkets' && get_profile.state === 'Full'"
            to="/deposit-funds"
            :button-text="$t('Fund your account')"
          />
        </div>
      </template>
    </Header>
    <iframe
      v-if="whitelabel === 'Blackstone'"
      allowtransparency="true"
      border="0"
      height="100%"
      scrolling="yes"
      src="https://blackstonefutures.co.za/banner/"
      style="border: 0"
      width="100%"
    ></iframe>
    <h5
      v-if="whitelabel === 'Blackstone'"
      class="flex text-gray-700 text-sm mt-2 justify-center"
    >
      <svg
        class="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
      MT4 servers: BlackstoneFutures-LiveBravo | BlackstoneFutures-DemoBravo
    </h5>
    <div
      v-if="whitelabel !== 'OrbitInvest'"
      class="sm:px-6 bg-white flex overflow-auto whitespace-nowrap"
    >
      <div v-for="(backend, index) in get_demo_backend_accounts" :key="index">
        <button
          v-if="
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === 'Live').length !== 0 ||
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === 'Demo').length !== 0
          "
          :class="
            selectedTab === backend.backend.type
              ? 'border-b-2 border-blue-900'
              : ''
          "
          class="px-4 py-3 mr-4 focus:outline-none border-b-2 border-transparent inline-block whitespace-normal"
          @click="selectedTab = backend.backend.type"
        >
          <img
            v-if="backend.backend.type === 'DXTrade'"
            :src="checkAsset(backend.backend.type)"
            alt=""
            class="h-6 w-auto"
          />
          <img
            v-else
            :src="checkAsset(backend.backend.type)"
            alt=""
            class="h-6"
          />
        </button>
      </div>
    </div>
    <complete-id-identification
      v-if="
        $store.getters.get_profile.state !== 'Full' &&
        $store.getters.get_profile.state !== 'Demo' &&
        $store.getters.get_profile.state !== 'Limited' &&
        (whitelabel === 'ICMEU' ||
          whitelabel === 'ICMCapital' ||
          whitelabel === 'ICMMENA' ||
          whitelabel === 'GCCBrokers' ||
          whitelabel === 'TradiNext' ||
          whitelabel === 'ICMTrader' ||
          whitelabel === 'ICMAP' ||
          whitelabel === 'TD365' ||
          whitelabel === 'TDSouthAfrica' ||
          whitelabel === 'EagleGlobalMarkets' ||
          whitelabel === 'TradeCoreUK' ||
          whitelabel === 'OrbitInvest' ||
          whitelabel === 'OneTradingMarkets')
      "
      :title="
        $t('further-id-verification-required-to-progress-account-application')
      "
    >
    </complete-id-identification>
    <alert-message
      :show-title="whitelabel !== 'VCGMarkets'"
      v-if="this.alertMessage.message !== ''"
      :alertMessage="this.alertMessage.message"
      :link="this.alertMessage.link"
      :linkText="this.alertMessage.linkText"
    >
    </alert-message>
     <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
      <!-- <complet-id-identification
          v-if="whitelabel==='ICMMU' && profileLoaded && showTaxAlert">
          <TaxDetailsAlert/>
      </complet-id-identification>  -->
    <div
      v-if="
        $store.getters.get_profile.state === 'Full' &&
        whitelabel === 'OrbitInvest'
      "
      class="sm:p-6 mt-4"
    >
      <div class="p-2 text-gray-500 font-light flex summary-info">
        <span class="block">Trading Account</span>
        <div class="summary-info__data">
          Total investment
          <span class="font-medium">{{
            $store.getters.get_user_data.extra.total_investment
          }}</span>
        </div>
      </div>
      <div class="p-2 text-gray-500 font-light flex summary-info">
        <span class="block">Profit Account</span>
        <div class="summary-info__data">
          Cash Balance
          <span class="font-medium">{{
            $store.getters.get_user_data.extra.total_profits
          }}</span>
        </div>
      </div>
    </div>
    <div
      v-for="(backend, index) in get_demo_backend_accounts"
      v-if="
        backend.backend.type === selectedTab && whitelabel !== 'OrbitInvest'
      "
      :key="index"
      class="sm:p-6 mt-4"
    >
    <!-- BR#157 -	ICMVC : trading accounts with backend ICMVC_MT4 (Live2) , not to display in ICM Access - 11/02/2026 Mbeng -->
      <div class="p-2 text-gray-500 font-light flex">
        <span class="block"> {{ $t("live-accounts") }} </span>
        <span class="px-1 bg-white border rounded text-sm mx-1 text-blue-900">
          {{
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === "Live") 
              .filter((item) => item.backend.name !== "ICMVC_MT4 (Live2)")
              .length
          }}
        </span>
      </div>
      <!-- BR#157	ICMVC : trading accounts with backend ICMVC_MT4 (Live2) , not to display in ICM Access - 11/02/2026 Mbeng -->
      <card
        v-for="(data, index) in get_account_data
          .filter((item) => item.backend.type === backend.backend.type)
          .filter((item) => item.backend.mode === 'Live')
          .filter((item) => item.backend.name !== 'ICMVC_MT4 (Live2)')"
        :key="index + 'Live'"
        :data="data"
      />
      <div class="p-2 text-gray-500 font-light mt-16 flex">
        <span class="block"> {{ $t("demo-accounts") }} </span>
        <span class="px-1 bg-white border rounded text-sm mx-1 text-blue-900">
          {{
            get_account_data
              .filter((item) => item.backend.type === backend.backend.type)
              .filter((item) => item.backend.mode === "Demo").length
          }}
        </span>
      </div>
      <card
        v-for="(data, index) in get_account_data
          .filter((item) => item.backend.type === backend.backend.type)
          .filter((item) => item.backend.mode === 'Demo')"
        :key="index + 'Demo'"
        :data="data"
      />
    </div>
    <add-demo-account-modal
      v-if="showAddDemoAccountModal"
      @close="closeModal"
    />
    <add-live-account-modal v-if="showAddAccountModal" @close="closeModal"/>
    <!--  #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025 -->
    <BecomeABrokerPopup
      :visible="showBecomeBrokerPopup"
      @close="showBecomeBrokerPopup = false"
      @submit="sendBrokerRequest"
    />
    <gcc-demo-popup
      v-if="showGccDemoPopup"
      @close="closeGccPopup"
      @continue="continueGccPopup"
    ></gcc-demo-popup>
    <icm-academy-modal v-if="showIcmAcademyModalComputed" @close="closeModal" />
    <icm-popup v-if="showICMPopup" />
    <icmcapital-unsuitable-modal
      v-if="$store.getters.get_icm_capital_suitable_modal"
    />

     <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details--> 
     <!-- BR#188 mbeng 2/6/2026 -->
     <!-- <TaxDetailsPopup v-if="whitelabel ==='ICMMU'&& $store.getters.get_profile.state === 'Full' && profileLoaded && showTaxPopup" -->
     <!-- BR#222 - Mbeng - 14/09/2026 included inactive and dormant states-->
     <div >
        <div v-if="whitelabel ==='ICMMU' && ($store.getters.get_profile.state === 'Full' || $store.getters.get_profile.state === 'Inactive' || $store.getters.get_profile.state === 'Dormant')" >
          <!--BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU corprate -->
            <HighRiskCorpratePopup
                v-if="isAllowedEmailPopup()"
                :visible="showHighRiskCorpratePopup"
                :deadline="deadlineDate"
                @close="handleHighRiskCorprateClose"
            />
            <TaxDetailsPopup 
               v-if="!isAllowedEmailPopup() && showTaxPopup"
               :visible="showTaxPopup"
               :deadline="deadlineDate"
               @close="handleTaxPopupClose"
            />
        
       </div>
     </div>

    <proof-of-id-modal
      v-if="$store.getters.get_icm_proof_modal === 'ID Proof'"
      :documents="['ID Proof']"
    ></proof-of-id-modal>
    <!-- #BR#98 Mbeng 9/06/2025 For ICMMU Tax details-->
     <!-- <TaxDetailsPopup v-if="whitelabel ==='ICMMU' && $store.getters.get_profile.state === 'Full' && profileLoaded && showTaxPopup "
      :visible="showTaxPopup"
      :deadline="deadlineDate"
      @close="handleTaxPopupClose"
    />  -->
   <!-- #BR#103 Mbeng 14/07/2025 SwapFreePopup for the list of trading account groups -->
   <SwapFreeGroup v-if="showSwapFreePopup && profileLoaded"
      :visible="showSwapFreePopup"
      @close="closeModal">
    </SwapFreeGroup>

   <!--BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country -->
   <!-- <HighRiskCountryPopup
      v-if="whitelabel === 'ICMMU' && isHighRiskCountry && isJoinedDate() &&  ($store.getters.get_profile.state === 'Full' || $store.getters.get_profile.state === 'Pending')"
      :visible="showHighRiskCountryPopup"
      @close="handleHighRiskCountryClose"
    /> -->
   <!--BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU-High risk corprate -->
   <!-- <HighRiskCorpratePopup
      v-if="isAllowedEmailPopup()"
      :visible="showHighRiskCorpratePopup"
      @close="handleHighRiskCorprateClose"
    /> -->

    <!-- BR#112 - Mbeng  - 26/08/2025 - add webinar popup -->
    <Webinar 
      :visible="showWebinarPopup"
      @close="handleWebinarClose"
    />

    <!-- BR#158 - Mbeng  - 12/02/2026 - add spotindices popup -->
    <SpotIndices 
      :visible="showSpotIndicesPopup"
      @close="handleSpotIndicesClose"
    />
    <!-- BR#175 - Mbeng  - 20/04/2026 - add VC closing  popup -->
    <VcClosingPopup 
      :visible="showVcClosingPopup && whitelabel ==='ICMVC'"
      @close="handleVcClosingPopupClose"
    />

    <!-- BR#179 - Mbeng  - 20/04/2026 - add MU SwapFreeDiscontinue closing  popup -->
    <!-- <SwapFreeDiscontinue 
      :visible="showSwapFreeDiscontinue && whitelabel ==='ICMMU'"
      @close="handleSwapFreeDiscontinueClose"
    /> -->

     <!-- BR#167 - Mbeng  - 25/03/2026 - add LevelAdjustment popup -->
    <!-- <LevelAdjustmentPopup 
      :visible="showLevelAdjustmentPopup && (whitelabel === 'ICMMU' || whitelabel ==='ICMVC' || whitelabel ==='ICMMENA')"
      @close="handleLevelAdjustmentPopupClose"
    /> -->
    <!-- BR#167 - Mbeng  - 25/03/2026 - add LevelAdjustment popup -->
    <!-- <LevelAdjustmentPopupFarsi
      :visible="showLevelAdjustmentPopupFarsi  && whitelabel==='ICMTrader'"
      @close="handleLevelAdjustmentPopupFarsiClose"
    /> -->

    <!-- BR#124 - Mbeng  - 10/09/2025 - add webinar popup -->
    <Webinaren 
      :visible="showWebinarenPopup"
      @close="handleWebinarenClose"
    />

     <!-- BR#135 - Mbeng  - 15/10/2025 - add webinarAssia popup -->
    <WebinarAssia 
      :visible="showWebinarAssiaPopup"
      @close="handleWebinarAssiaClose"
    />

    <!-- BR#209 - Mbeng  - 18/08/2026 - add MU KycReminder notification  popup -->
    <!-- BR#222 - Mbeng - 14/09/2026 included inactive and dormant states-->
    <KycReminder 
      :visible="
        showKycReminder &&
        whitelabel === 'ICMMU' &&
        ($store.getters.get_profile.state === 'Full' ||
         $store.getters.get_profile.state === 'Inactive' ||
         $store.getters.get_profile.state === 'Dormant'
        )
      "
      @close="handleKycReminderClose"
    />
    <!-- BR#209 - Mbeng  - 18/08/2026 - add MU KycReminderExpired notification  popup -->
    <!-- BR#222 - Mbeng - 14/09/2026 included inactive and dormant states-->
    <KycReminderExpired 
      :visible="
        showKycReminderExpired &&
        whitelabel === 'ICMMU' &&
        ($store.getters.get_profile.state === 'Full' ||
        $store.getters.get_profile.state === 'Inactive' ||
         $store.getters.get_profile.state === 'Dormant'
        )
      "
      @close="handleKycReminderExpiredClose"
    />

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MoneyFormat from "vue-money-format";
import AddDemoAccountModal from "@/views/trading-accounts/AddDemoAccountModal";
import AddLiveAccountModal from "@/views/trading-accounts/AddLiveAccountModal";
import Header from "@/components/Header";
import Card from "@/views/trading-accounts/Card";
import CompleteIdIdentification from "@/components/CompleteIdIdentification";
import GccDemoPopup from "@/views/trading-accounts/GccDemoPopup";
import IcmAcademyModal from "@/views/trading-accounts/IcmAcademyModal";
import IcmcapitalUnsuitableModal from "@/views/register/IcmcapitalUnsuitableModal";
import AlertMessage from "@/components/AlertMessage.vue";
import LinkButton from "@/components/LinkButton.vue";
import ButtonComponent from "@/components/Button.vue";
import IcmPopup from "@/views/trading-accounts/ICMPopup.vue";
import LimitedStateUpgradeModal from "@/views/LimitedStateUpgradeModal.vue";
import ProofOfIdModal from "@/views/ProofOfIdModal.vue";

// #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
import BecomeABrokerPopup from "./BecomeABrokerPopup.vue"; 

import TaxDetailsAlert from "@/components/TaxDetailsAlert.vue"; //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
import TaxDetailsPopup from "@/components/TaxDetailsPopup.vue"; //BR#98 Mbeng 9/06/2025 For ICMMU Tax details

import SwapFreeGroup from "@/components/SwapFreeGroup.vue"; //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts groups
import Webinar from "@/components/Webinar.vue"; //  BR#112	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
import Webinaren from "@/components/Webinaren.vue";  //BR#124
import SpotIndices from "@/components/SpotIndices.vue"; //BR#158
import WebinarAssia from "@/components/WebinarAssia.vue";  //BR#135
import LevelAdjustmentPopup from "@/components/LevelAdjustmentPopup.vue"; //BR#167
import LevelAdjustmentPopupFarsi from "@/components/LevelAdjustmentPopupFarsi.vue"; //BR#167
import VcClosingPopup from "@/components/VcClosingPopup.vue"; //BR#175
import SwapFreeDiscontinue from "@/components/SwapFreeDiscontinue.vue"; // BR#179
import HighRiskCountryPopup from "@/components/HighRiskCountryPopup.vue"; //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
import HighRiskCorpratePopup from "@/components/HighRiskCorpratePopup.vue"; //BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU-corprate user
import KycReminder from "@/components/KycReminder.vue"; //BR#209;
import KycReminderExpired from "@/components/KycReminderExpired.vue"; //BR#209;
export default {
  name: "AccountSummary",
  components: {
    ProofOfIdModal,
    LimitedStateUpgradeModal,
    IcmPopup,
    ButtonComponent,
    LinkButton,
    Card,
    AddDemoAccountModal,
    AddLiveAccountModal,
    Header,
    "money-format": MoneyFormat,
    CompleteIdIdentification,
    AlertMessage,
    GccDemoPopup,
    IcmAcademyModal,
    IcmcapitalUnsuitableModal,
    BecomeABrokerPopup,   // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
    TaxDetailsAlert,  //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    TaxDetailsPopup, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details

    LevelAdjustmentPopup, //BR#167 Mbeng Popup: level adjustment 24/03/2026
    LevelAdjustmentPopupFarsi, //BR#167 Mbeng Popup: level adjustment 24/03/2026
    HighRiskCountryPopup, //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
    HighRiskCorpratePopup, //BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU-corprate users

    SwapFreeGroup, //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading account groups
    SpotIndices, //BR#158 Mbeng Popup: Margin Requirement Changes for Spot Indices 12/02/2026
    Webinar,  // BR#112	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
    Webinaren,  // BR#124	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC 26/08/2025 Mbeng
    WebinarAssia,  // BR#135	add a pop-up on ICM Access for upcoming AR webinar ICMMU & ICMVC  Malasia, Indonesia, thailand 15/10/2025 Mbeng
    VcClosingPopup, // BR#175 added popup for vc account closure mbeng 21/04/2026
    SwapFreeDiscontinue, // BR#179 20/04/2026 - add MU SwapFreeDiscontinue closing  popup
    KycReminder, // BR#209
    KycReminderExpired, // BR#209
  },
  data() {
    return {
      showAddDemoAccountModal: false,
      showAddAccountModal: false,
      showBecomeBrokerPopup: false,  // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
      showMenu: false,
      stage: "",
      whitelabel: process.env.VUE_APP_WHITELABEL,
      selectedTab: "",
      showGccDemoPopup: false,

      intervalId: null,
      accountDataIntervalId: null,

      showLevelAdjustmentPopup: false, //BR#167 - mbeng -25/03/2026
      showLevelAdjustmentPopupFarsi: false, //BR#167 - mbeng -25/03/2026

      showVcClosingPopup: false, //BR#175 - Mbeng  - 20/04/2026
      showSwapFreeDiscontinue: false, //BR#179 -Mbeng - 27/04/2026 
      showHighRiskCountryPopup: false, //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
      showHighRiskCorpratePopup: false, //BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU-corprate-users

      showSwapFreePopup: false, //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts groups
      showWebinarPopup: false, //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
      showSpotIndicesPopup: false, //BR158 - mbeng -12/02/2026 - Popup: Margin Requirement Changes for Spot Indices
      showWebinarenPopup: false, //BR#124 - Mbeng  - 26/08/2025 
      showWebinarAssiaPopup: false, //BR#135 - Mbeng  - 15/10/2025 

      showTaxPopup: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      menuLocked: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      userLoaded: false, //BR#98 Mbeng 9/06/2025 For ICMMU Tax details
      deadlineDate: new Date("2026-07-11T23:59:59"), //BR#98 Mbeng 9/06/2025 For ICMMU Tax details BR#200
      showKycReminder: false, //BR#209 -Mbeng - 18/08/2026 
      showKycReminderExpired: false, //BR#209 -Mbeng - 18/08/2026 
    };
  },
  computed: {
    ...mapGetters([
      "get_auth_user", //BR#181
      "get_account_data",
      "get_profile",
      "get_user_data",
      "get_icm_academy_modal",
      "get_icm_capital_suitable_modal",
      "get_country_risk_map", //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
     
    ]),

    //BR#112  - Mbeng  - 26/08/2025 - add webinar popup - BR#124 - 10/09/2024
    profileLang() {
      return this.get_profile?.profile?.language || null;
    },
    profileWL() {
      return this.get_profile?.whitelabel || null;
    },
    profileCountry() {
      return this.get_profile?.address?.addr_country || null;
    
    },

    alertMessage() {
      let message = "";
      let link = "";
      let linkText = "";

      const profile = this.$store.getters.get_profile;
      const trading_days = this.$store.getters.get_trading_days;
      const state = profile.state;

      if (this.whitelabel === "VCGMarkets" && state === "Limited") {
        if (trading_days === null) {
          return {
            message: "Please, make a deposit transaction.",
            link: "/deposit-funds",
            linkText: "Deposit funds",
          };
        } else {
          if (trading_days === 0) {
            return {
              message: "Please verify your account to enable deposits.",
            };
          }
          return {
            message: `Please, upload your documents in next ${trading_days} days.`,
          };
        }
      }

      if (
        (this.whitelabel === "ICMVC" && state === "Pending") ||
        (this.whitelabel === "ICMSC" && state === "Pending") || //BR#52
        (this.whitelabel === "ICMMU" && state === "Pending")
      ) {
        // documents status
        // 1 - pending
        // 2 - approved
        // 3 - rejected
        // 4 - failed
        const documents = this.$store.getters.get_uploaded_documents?.results;
        const idProof = documents?.find(
          (document) => document.document_type === "ID Proof"
        );
        // if (documents?.length === 0 && this.whitelabel === "ICMVC") {
        //   message = this.$t(
        //     "further-id-verification-required-to-progress-account-application"
        //   );
        //   //link = "/upload-documents";
        //  // linkText = "Click here to upload.";
        // }

        //#BR#23 - mbeng Atemson - 23/10/2024 - KYC verification for iCMMU 
        //#BR#73 - mbeng Atemson - 23/10/2024 - KYC verification for iCMVC 
        //#BR#52 - mbeng Atemson - 25/7/2025 - KYC verification for iCMSC 
        // BR#224 Sunny 15/09/2026 Provide the sumsub KYC link in the client portal for ICMMU-Pending clients -->
        if (state === "Pending" && this.whitelabel === "ICMMU") {
          link = "kyc-submit";

          return {
            link,
          };
        }
        // BR#224 end

        //#BR#215 - mbeng Atemson - 5/9/2026 - KYC verification for iCMMU adding contact support
        if (documents?.length === 0 && (this.whitelabel === "ICMMU" || this.whitelabel === 'ICMVC' || this.whitelabel === 'ICMSC')) {
          message = this.$t("kyc-verification-is-pending-please-contact-support");
          //#BR#23 - Removed click here to upload link for iCMMU - mbeng Atemson - 23/10/2024
          //link = "/upload-documents";     
          //linkText = "Click here to upload.";
        }


        if (idProof) {
          if (idProof?.status === 1) {
            message =
              "We're currently verifying your details. Please bear with us.\n" +
              "Thank you for your patience.";
          }
          //#BR#73 - KYC verification for iCMMU - mbeng Atemson - 09/04/2025
          // if (idProof.status === 3 && state === "Pending" && this.whitelabel === "ICMVC") {
          //   message =
          //     "Further ID verification required to progress account application.";
          //   link = "/upload-documents";
          //   linkText = "Click here to upload.";
          // }

          //#BR#23 - KYC verification for iCMMU - mbeng Atemson - 23/10/2024
          //#BR#73 - KYC verification for iCMMU - mbeng Atemson - 09/04/2025
          //#BR#52 - KYC verification for iCMSC - mbeng Atemson - 24/07/2025
          //#BR#215 - mbeng Atemson - 5/9/2026 - KYC verification for iCMMU adding contact support
          if (idProof.status === 3 && state === "Pending" && (this.whitelabel === "ICMMU" || this.whitelabel ==="ICMVC" || this.whitelabel === 'ICMSC')) {
            message = this.$t("kyc-verification-is-pending-please-contact-support")
            //#BR#23 - Removed click here to upload link for iCMMU - mbeng Atemson - 23/10/2024
            //link = "/upload-documents";
            //linkText = "Click here to upload.";
          }
        }
      }

      return {
        message,
        link,
        linkText,
      };
    },
    get_demo_backend_accounts() {
      let data = this.$store.getters.get_demo_backend_accounts;
      if (this.$store.getters.get_demo_backend_accounts.length === 0) {
        data = this.$store.getters.get_live_backend_accounts;
      }
      let accountData = this.$store.getters.get_account_data;
      if (accountData.length > 0) {
        let result = accountData.filter(function (o1) {
          // filter out (!) items in result2
          return !data.some(function (o2) {
            return o1.backend.type === o2.backend.type; // assumes unique id
          });
        });
        result = data.concat(result).reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.backend.type === o.backend.type &&
                obj.backend.type === o.backend.type
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);

        // BR#177	Hide Ctrader in all ICM Access portals - Account summary tab - mbeng - 24/04/2026
        // result = result.filter(
        //   (item) => item.backend.type !== "CTrader"
        // );
        result = result.filter(
          (item) =>
            item.backend.type &&
            !item.backend.type.toLowerCase().includes("ctrader")
        );

        // client wanted MT4 to be always as first tab and cTrader to be last tab
        // we check if there is a object with backend type of MT4
        // if it does, we check if its Index is not in the first position of bekend accounts
        // if its not, we reverse the order of array so he ends up in first place
        const mt4exist = result.some((object) => object.backend.type === "MT4");
        if (mt4exist) {
          if (
            result.findIndex((object) => object.backend.type === "MT4") !== 0
          ) {
            result.reverse();
          }
        }

        // this will loop through all trading backend types and check if it has active accounts
        // if it has, we can then set the selected tab to that one
        // this is places so we dont select a tab that we might not show, since we added a filter not to show tabs with no accounts
        for (const key in result) {
          if (
            accountData
              .filter((item) => item.backend.type === result[key].backend.type)
              .filter((item) => result[key].backend.mode === "Live").length !==
              0 ||
            accountData
              .filter((item) => item.backend.type === result[key].backend.type)
              .filter((item) => result[key].backend.mode === "Demo").length !==
              0
          ) {
            this.selectedTab = result[key].backend.type;
          }
        }

        // this function will sort tabs (backend types) based on the number of trading accounts that have that backend type
        // we loop through all backend types and then add all live and demo accounts with that bakend types, then compare with live + demo accounts from the other backend type from the array
        // this is the logic (p1, p2) => (p1.price < p2.price) ? 1 : (p1.price > p2.price) ? -1 : 0);
        // code taken from here https://www.scaler.com/topics/javascript-sort-an-array-of-objects/
        if (this.whitelabel === "TradeCoreUK") {
          let sortedProducts = result.sort((p1, p2) =>
            parseInt(
              accountData
                .filter((item) => item.backend.type === p1.backend.type)
                .filter((item) => p1.backend.mode === "Live").length
            ) +
              parseInt(
                accountData
                  .filter((item) => item.backend.type === p1.backend.type)
                  .filter((item) => p1.backend.mode === "Demo").length
              ) <
            parseInt(
              accountData
                .filter((item) => item.backend.type === p2.backend.type)
                .filter((item) => p2.backend.mode === "Live").length
            ) +
              parseInt(
                accountData
                  .filter((item) => item.backend.type === p2.backend.type)
                  .filter((item) => p2.backend.mode === "Demo").length
              )
              ? 1
              : parseInt(
                  accountData
                    .filter((item) => item.backend.type === p1.backend.type)
                    .filter((item) => p1.backend.mode === "Live").length
                ) +
                  parseInt(
                    accountData
                      .filter((item) => item.backend.type === p1.backend.type)
                      .filter((item) => p1.backend.mode === "Demo").length
                  ) >
                parseInt(
                  accountData
                    .filter((item) => item.backend.type === p2.backend.type)
                    .filter((item) => p2.backend.mode === "Live").length
                ) +
                  parseInt(
                    accountData
                      .filter((item) => item.backend.type === p2.backend.type)
                      .filter((item) => p2.backend.mode === "Demo").length
                  )
              ? -1
              : 0
          );
        }

        // this.selectedTab = result[0].backend.type
        return result;
      }
    },
    showICMPopup() {
      return this.$store.getters.get_icm_popup;
    },
    showIcmAcademyModalComputed() {
      if (this.$store.getters.get_profile.address !== undefined) {
        const userCountry =
          this.$store.getters.get_profile.address?.addr_country; // get user country
        const isIcmAcademyModal = this.$store.getters.get_icm_academy_modal; // get a boolean for ICM Academy modal
        const whitelabel = this.whitelabel;

        // Check the conditions
        //BR#52
        if (
          isIcmAcademyModal &&
          (whitelabel === "ICMVC" || whitelabel === "ICMMU" || whitelabel === "ICMSC") &&
          !["Malaysia", "Vietnam", "Thailand", "Indonesia"].includes(
            userCountry
          )
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },

// #BR#98 Mbeng 9/06/2025 For ICMMU Tax details
mounted() {
  const profile = this.$store.getters.get_profile;
  const accounts = this.$store.getters.get_profile?.trading_accounts || [];
  this.tryHighRiskPopup(this.get_profile);  //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
  this.isJoinedDate(); //BR#181
    if (profile?.nic_fields?.length > 0) {
      this.checkTaxPopup(profile);
    };

  // BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
  if ( accounts && Array.isArray(accounts)
      ) {
         this.checkGroupEligibility(accounts);
      };

  this.checkWebinarPopup();   // Webinar popup //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
  this.checkWebinarenPopup();  // BR#124 - Mbeng - 10/09/2025
  this.checkWebinarAssiaPopup();  // BR#135 - Mbeng - 15/10/2025
  this.checkSpotIndicesPopup();  // BR#158 - Mbeng - 12/02/2026
  this.checkLevelAdjustmentPopup();  // BR#167 - Mbeng - 24/03/2026
  this.checkLevelAdjustmentPopupFarsi();  // BR#167 - Mbeng - 24/03/2026
  this.checkVcClosingPopup();  // BR#175 - Mbeng - 20/04/2026
  this.checkSwapFreeDiscontinue(); //BR#179 - Mbeng - 27/04/2026
  this.isHighRiskCountry(); //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
  this.isAllowedEmailPopup(); //BR#188 - Mbeng -21/05/2026
  this.checkKycReminder(profile); //BR#209 - Mbeng - 18/08/2026
  
},

  created() {
    this.$store.dispatch("account_data").catch((error) => {
      //console.error("Error dispatching 'account_data': ", error);
    });
    this.stage = process.env.VUE_APP_API_URL.includes("dev.")
      ? "dev"
      : process.env.VUE_APP_API_URL.includes("stage.")
      ? "stage"
      : "production";

    if (this.whitelabel === "GCCBrokers") {
      this.showGccDemoPopup = this.$store.getters.get_gcc_demo_popup;
    }

    if (this.whitelabel === "GCCBrokers") {
      this.showGccDemoPopup = this.$store.getters.get_gcc_demo_popup;
    }
  //BR#52 ERR#86 - (icmsc whitelabel updated to this.whitelabel,) whitelable not define console error - 7/7/2026
    if (this.whitelabel === "ICMVC" || this.whitelabel === "ICMMU" || this.whitelabel === "ICMSC") {
      this.fetchUserDocs();
      // Initialize the interval and save intervalId to the component instance
      this.intervalId = setInterval(() => this.fetchUserDocs(), 10000); // Fetch user data every 10 seconds
    }
    this.fetchProfileData();

    // Initialize the interval and save intervalId to the component instance
    this.accountDataIntervalId = setInterval(
      () => this.fetchProfileData(),
      15000
    ); // Fetch user data every 15 seconds
  },

  watch: {
    //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
    //BR#124 - Mbeng  - 10/09/2025 - add webinar popup
    // Re-check only when the relevant fields change
    profileLang() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },
    profileWL() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },
    profileCountry() {
      this.checkWebinarPopup();
      this.checkWebinarenPopup();
      this.checkWebinarAssiaPopup();
    },


    get_profile: {
        handler(profile) {
          if (!profile) return;

          // Tax popup
          if (Array.isArray(profile.nic_fields) && profile.nic_fields.length > 0) {
            this.checkTaxPopup(profile);
          } else {
            setTimeout(() => {
              const refreshed = this.$store.getters.get_profile;
              if (refreshed?.nic_fields?.length > 0) {
                //console.log(" Retried and found NIC fields:", refreshed.nic_fields);
                this.checkTaxPopup(refreshed);
              } else {
                console.warn(" Still no NIC fields after delay");
              }
            }, 300);
          }

          // BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
          if (Array.isArray(profile.trading_accounts) && profile.trading_accounts.length > 0) {
            //console.log(" Trading accounts found:", profile.trading_accounts);
            this.checkGroupEligibility(profile.trading_accounts);
          } else {
            console.warn(" No trading accounts found in profile");
          }
           this.tryHighRiskPopup(profile); //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
           //this.isJoinedDate(); //BR#181

            // KYC Reminder BR#209
            if (profile?.nic_fields?.length) {
              this.checkKycReminder(profile);
              
            }
           
        },
        immediate: true,
        deep: true,
       
      },
      //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
      get_country_risk_map: {
        handler() {
          this.tryHighRiskPopup(this.get_profile);
        },
        immediate: true,
        deep: true,
      },

      // get_auth_user: {
      //   immediate: true,
      //   handler(user) {
      //     if (!user?.email) return;

      //     const email = user.email.toLowerCase().trim();

      //     const isAllowed = this.allowedPopupEmails()
      //       .map(e => e.toLowerCase().trim())
      //       .includes(email);

      //     this.showHighRiskCorpratePopup = isAllowed;
      //   }
      // }
  },

  methods: {
    fetchProfileData() {
      this.$store
        .dispatch("profile")
        .then((res) => {
          const profile = this.$store.getters["get_profile"];
          const state = profile.state;

          //console.log("Profile state is: ", state, "Checking is in progress");
          if (state === "Full" || state === "Limited") {
            this.$store.dispatch("account_data").catch((error) => {
              console.error("Error dispatching 'account_data': ", error);
            });
          }

          if (state === "Full") {
            clearInterval(this.accountDataIntervalId);
            const checkWhenLiveAccountCreated = profile.trading_account?.find(
              (account) => account.Type === "Live"
            )?.created;
            const isLessThenMinute =
              new Date() - new Date(checkWhenLiveAccountCreated) < 60000;
            if (isLessThenMinute) {
              this.$notify({
                group: "foo",
                text: "Registration Complete, Live Account Added!",
                type: "success",
              });
            }

            //console.log("Checking is done, current state is: ", state);
          }
        })
        .catch((error) => {
          console.error("Error in 'fetchProfileData': ", error);
        });
    },

    fetchUserDocs() {
      const documents = this.$store.getters.get_uploaded_documents?.results;
      const status = this.$store.getters.get_profile.state;

      const idProof = documents?.find(
        (document) => document.document_type === "ID Proof"
      );

      const needToFetch = idProof?.status !== 2 && status !== "Limited";
      if (needToFetch) {
        this.$store.dispatch("set_uploaded_documents");
      } else {
        clearInterval(this.intervalId);
      }
    },
    closeModal() {
      this.showAddDemoAccountModal = false;
      this.showAddAccountModal = false;
      this.showBecomeBrokerPopup = false;  // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
      this.showIcmAcademyModal = false;
      this.showSwapFreePopup = false; //BR#103 Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group
      this.showWebinarPopup = false; //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
      this.showWebinarenPopup = false; //BR#124 - Mbeng  - 10/09/2025
      this.showWebinarAssiaPopup = false; //BR#135 - Mbeng  - 15/10/2025
      this.showSpotIndicesPopup = false; //BR#158 - Mbeng  - 12/02/2026
      this.showLevelAdjustmentPopup = false; //BR#167 - Mbeng  - 12/02/2026
      this.showLevelAdjustmentPopupFarsi = false; //BR#167 - Mbeng  - 12/02/2026
      this.showTaxPopup = false; //BR#98 - mbeng - 31/03/2026
      this.showVcClosingPopup = false; //BR#175 - mbeng - 20/04/2026
      this.showSwapFreeDiscontinue = false; //BR#179 - mbeng - 27/04/2026
      this.showHighRiskCountryPopup = false; //BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
      this.showHighRiskCorpratePopup = false; //BR#188 - Mbeng - 21/05/2026 - pop-up for ICMMU-corprate-users
      this.showKycReminder = false; //BR#209 - mbeng - 18/08/2026
      this.showKycReminderExpired = false; //BR#209 - mbeng - 18/08/2026
    },

    //#BR#98 Mbeng 9/06/2025 For ICMMU Tax details
    startCountdown() {
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.lockMenu();
          clearInterval(this.intervalId);
        }
      }, 1000); // update every second
    },
    lockMenu() {
      this.menuLocked = true;
      this.$store.commit("LOCK_MENU_ITEMS"); // Vuex control
    },
    dismissPopup() {
      //clearInterval(this.intervalId);
      this.showTaxPopup = false;
      localStorage.setItem("tax_popup_dismissed", "true");
    },

    //BR#98 - Mbeng - show taxdetail popup if code !== TIN or value is empty - 8/7/2025 
    checkTaxPopup(profile) {

      const dismissed = sessionStorage.getItem("TaxPopupDismissed") === "1";
      if (dismissed) {
        this.showTaxPopup = false;
        return;
      }

      //BR#188
      const email = this.get_auth_user?.email?.toLowerCase()?.trim();

      const isAllowed = this.allowedPopupEmails()
        .map(e => e.toLowerCase().trim())
        .includes(email);

      // Skip everything for whitelisted emails
      if (isAllowed) {
        this.showTaxPopup = false;
        this.profileLoaded = true;
        return;
      }


      const nicFields = profile.nic_fields || [];
      const requiredPriorities = [3, 4, 5, 6];

      // Look for at least one valid TIN in required priorities
      const hasValidTIN = requiredPriorities.some(priority => {
        const field = nicFields.find(n => n.priority === priority);
        return field && field.code === 'TIN' && field.value;
      });

      this.showTaxAlert = !hasValidTIN;
      this.showTaxPopup = !hasValidTIN;
      this.profileLoaded = true;
      this.userLoaded = true;
      },

     handleTaxPopupClose() {
        // Close + remember for this session so it won't pop again on any click/state change
        this.showTaxPopup = false;
        sessionStorage.setItem("TaxPopupDismissed", "1");
      },

      //BR#112 - Mbeng  - 26/08/2025 - add webinar popup
    checkWebinarPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-08-25") && now <= new Date("2025-12-09");

      const matches =
        this.profileLang === "ar" &&
        (this.profileCountry !== "Malaysia" && this.profileCountry !== "Indonesia" && this.profileCountry !== "Thailand" && this.profileCountry !== "Vietnam") &&  //#BR#135
        this.profileWL === "ICMMU" &&
        //(this.profileWL === "ICMMU" || this.profileWL === "ICMVC") &&
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarPopup = !!matches;
    },

    handleWebinarClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },

  //BR#124 - Mbeng  - 10/09/2025 - add webinar popup
    checkWebinarenPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarenPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-08-25") && now <= new Date("2025-12-09");

      const matches =
        this.profileLang !== "ar" &&
        (this.profileCountry !== "Malaysia" && this.profileCountry !== "Indonesia" && this.profileCountry !== "Thailand" && this.profileCountry !== "Vietnam" ) &&  //#BR#135
        this.profileWL === "ICMMU" &&
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarenPopup = !!matches;
    },

    handleWebinarenClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarenPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },


    //BR#135 - Mbeng  - 15/10/2025 - add webinarAssia popup
    checkWebinarAssiaPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showWebinarAssiaPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2025-10-01") && now <= new Date("2025-12-31");

      const matches =
        this.profileWL === "ICMMU" && 
        (this.profileCountry === "Malaysia" || this.profileCountry === "Indonesia"|| this.profileCountry === "Thailand" || this.profileCountry === "Vietnam") &&  
        inRange;

      // Only show if rule matches and not dismissed this session
      this.showWebinarAssiaPopup = !!matches;
    },

    handleWebinarAssiaClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showWebinarAssiaPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },


      //BR#158 - Mbeng  - 12/02/2026 - add spotindices popup
    checkSpotIndicesPopup() {
      // If user already dismissed this session, never reopen
      const dismissed = sessionStorage.getItem("webinarPopupDismissed") === "1";
      if (dismissed) {
        this.showSpotIndicesPopup = false;
        return;
      }

      const now = new Date();
      const inRange =
        now >= new Date("2026-02-13") && now <= new Date("2026-02-20");
      const matches =
        inRange;

      // Only show if rule matches and not dismissed this session
      //this.showSpotIndicesPopup = true;
      this.showSpotIndicesPopup = !!matches;
    },

    handleSpotIndicesClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showSpotIndicesPopup = false;
      sessionStorage.setItem("webinarPopupDismissed", "1");
    },

    // BR#181 - Mbeng - 13/05/2026 - pop-up for ICMMU-High risk country
    isHighRiskCountry(profile) {
        const dismissed =
          sessionStorage.getItem("highRiskCountryPopupDismissed") === "1";

        if (dismissed) {
          this.showHighRiskCountryPopup = false;
          return false;
        }

        const countryCode =
          profile?.address?.addr_country_iso_code?.trim()?.toUpperCase();

        const riskData = this.get_country_risk_map;


        if (!countryCode || !riskData) {
          return false;
        }

        let riskType = null;

        if (Array.isArray(riskData)) {
          const match = riskData.find(
            c => c.iso_code === countryCode
          );
          riskType = match?.risk_type;
        }

        else if (typeof riskData === "object") {
          riskType = riskData[countryCode];
        }

        const shouldShow = riskType === "High risk" || riskType === "Other";


        this.showHighRiskCountryPopup = shouldShow;

        return shouldShow;
      },

    handleHighRiskCountryClose() {
        this.showHighRiskCountryPopup = false;

        // prevent reopening during session
        sessionStorage.setItem(
          "highRiskCountryPopupDismissed",
          "1"
        );
      },

    tryHighRiskPopup(profile) {
        if (!profile || !this.get_country_risk_map) return;

        this.isHighRiskCountry(profile);
      },
    
  dateOfJoining() {
    return this.get_auth_user?.date_joined || null;
  },

  isJoinedDate() {
    const rawDate = this.dateOfJoining();
    const user = this.$store.getters.get_auth_user;

    //console.log("Joining Date:", rawDate);
    //console.log("auth user data:", user);

    if (!rawDate) return false;
    const joinedDate = new Date(rawDate);
    // 01-05-2026 - month count starts from 0 - 11  4=May  5=June 2=march
    const compareDate = new Date(2026, 2, 1);
    return joinedDate.getTime() >= compareDate.getTime();
  },

  //BR#181 - End 
 
  //BR#188 - Mbeng - 
  allowedPopupEmails() {

      return [
      "backoffice@skylinkscapital.com",
      "Support@icmcapital.com",
      "sjezzini@supremefxtrading.com",
      "email@sugandhgroup.com",
      "ed@cmw.ae",
      "mrgalool@gmail.com",
      "fundtron@gmail.com",
      "subhirajaaacoount@gmail.com",
      "Paliwalh02@gmail.com",
      "aljahan.co@gmail.com",
      "gbsndxb@gmail.com",
      "jobbymathewphilip@gmail.com",
      "dragos.m@artisgain.com",
      "alkhabti.skyline@gmail.com",
      "Ayman.alhashmi7@gmail.com",
      "info@darinvestments.ae",
      "mathew.jobby1@gmail.com",
      "zikudemnguni@gmail.com",
      "office@orbit-invest.ae",
      "info@billionbees.ae",
      "admin@012sfbme.com",
      "partnerships@fxrebate.eu",
      "admrxsmart@gmail.com",
      "murtazahamdani53@gmail.com",
      "saqer.abdelfattah@aswaqinvest.com",
      "Sameer@saiy.co.za",
      "affreferltd@gmail.com",
      "shreyans.patwa@sugandhcommodities.com",
      "saqer.abdelfattah@aswaqinvest.comm",
      "accounts@supremefxtrdaing.com",
      "davevivek_om@hotmail.co.uk",
      "IBfundtron@gmail.com",
      "Tradezera@gmail.com",
      "marketing@artisgain.com",
      "Ahmed.skylinev@gmail.com",
      "m2490.25bb@gmail.com",
      "Realtimestories8@gmail.com",
      "mccxinvest@gmail.com",
      "ops@billionbeesfx.com",
      "Knassour@sfbme.com",
      "a5556@fxrebate.eu",
      "info@rxsmartglobal.com",
      "Saqer.abdelfattah@gmail.comm",
      "gerald@saiy.co.za",
      "amir@affrefer.com",
      "info@sugandhcommodities.com",

      //dev
      "krisdev0415+11220@gmail.com",
      "krisdev0415+11222@gmail.com",
      ];

    },

   isAllowedEmailPopup() {

      const dismissed =
        sessionStorage.getItem("highRiskCorpratePopupDismissed") === "1";

      if (dismissed) {
        this.showHighRiskCorpratePopup = false;
        return false;
      }

      const email = this.get_auth_user?.email
        ?.toLowerCase()
        ?.trim();

      // User data not loaded yet
      if (!email) {
        return false;
      }

      //console.log("Current User Email:", email);

      const isAllowedEmail = this.allowedPopupEmails()
        .map(e => e.toLowerCase().trim())
        .includes(email);

      //console.log("Is Allowed Email:", isAllowedEmail);

      const shouldShow =
        this.whitelabel === "ICMMU" &&
        isAllowedEmail;

      this.showHighRiskCorpratePopup = shouldShow;

      return shouldShow;
    },

    handleHighRiskCorprateClose() {
      this.showHighRiskCorpratePopup = false;

      // prevent reopening during session
      sessionStorage.setItem(
        "highRiskCorpratePopupDismissed",
        "1"
      );
    },
//End - BR#188

     //BR#167 - Mbeng  - 25/03/2026 - add level adjustment popup
    checkLevelAdjustmentPopup() {
       const dismissed = localStorage.getItem("levelAdjustmentPopupDismissed");

      if (dismissed === "1") {
        this.showLevelAdjustmentPopup = false;
        return;
      }

      this.showLevelAdjustmentPopup = true;
    },

    handleLevelAdjustmentPopupClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showLevelAdjustmentPopup = false;
      localStorage.setItem("levelAdjustmentPopupDismissed", "1");
    },

    checkLevelAdjustmentPopupFarsi() {
       const dismissed = localStorage.getItem("levelAdjustmentPopupDismissed");

      if (dismissed === "1") {
        this.showLevelAdjustmentPopupFarsi = false;
        return;
      }

      this.showLevelAdjustmentPopupFarsi = true;
    },

    handleLevelAdjustmentPopupFarsiClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showLevelAdjustmentPopupFarsi = false;
      localStorage.setItem("levelAdjustmentPopupDismissed", "1");
    },

     //BR#175 - Mbeng  - 20/04/2026 - add vc closing popup
    checkVcClosingPopup() {
       const dismissed = localStorage.getItem("VcClosingPopupDismissed");

      if (dismissed === "1") {
        this.showVcClosingPopup = false;
        return;
      }

      this.showVcClosingPopup = true;
    },

    handleVcClosingPopupClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showVcClosingPopup = false;
      localStorage.setItem("VcClosingPopupDismissed", "1");
    },

     //BR#179 - Mbeng  - 27/04/2026 - add mu closing popup
    checkSwapFreeDiscontinue() {
       const dismissed = localStorage.getItem("SwapFreeDiscontinueDismissed");

      if (dismissed === "1") {
        this.showSwapFreeDiscontinue = false;
        return;
      }

      this.showSwapFreeDiscontinue = true;
    },

    handleSwapFreeDiscontinueClose() {
      // Close + remember for this session so it won't pop again on any click/state change
      this.showSwapFreeDiscontinue = false;
      localStorage.setItem("SwapFreeDiscontinueDismissed", "1");
    },

     //BR#209 - Mbeng  - 18/08/2026 - add mu kyc reminder popup
   checkKycReminder(profile) {

      // Reset both popups first
      this.showKycReminder = false;
      this.showKycReminderExpired = false;

      const nicFields = profile?.nic_fields || [];

      // No NIC fields
      if (!Array.isArray(nicFields) || nicFields.length === 0) {
        return;
      }

      // Get priority 1 ID/passport
      const passport_id = nicFields.find(
        item => Number(item.priority) === 1
      );

      if (!passport_id?.value) {
        return;
      }

      // Expected format:
      // 23455 # 2034/01/01
      const passport_expiry = passport_id.value
        .split("#")[1]
        ?.trim();

      if (!passport_expiry) {
        return;
      }

      // Parse YYYY/MM/DD
      const [year, month, day] = passport_expiry
        .split("/")
        .map(Number);

      if (!year || !month || !day) {
        return;
      }

      const expiryDate = new Date(
        year,
        month - 1,
        day
      );

      const today = new Date();

      today.setHours(0, 0, 0, 0);
      expiryDate.setHours(0, 0, 0, 0);

      const daysUntilExpiry = Math.ceil(
        (expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
      );

      // EXPIRED

      if (daysUntilExpiry < 0) {

        const dismissedExpired = sessionStorage.getItem("KycReminderExpiredDismissed");

        if (dismissedExpired !== "1") {
          this.showKycReminderExpired = true;
        }

        return;
      }

      
      // EXPIRING WITHIN 60 DAYS

      if (daysUntilExpiry >= 0 && daysUntilExpiry <= 60) {

        const dismissed =
          sessionStorage.getItem(
            "KycReminderDismissed"
          );

        if (dismissed !== "1") {
          this.showKycReminder = true;
        }

        return;
      }

      
      // MORE THAN 60 DAYS

      this.showKycReminder = false;
      this.showKycReminderExpired = false;
    },
    handleKycReminderClose() {
      this.showKycReminder = false;
      //localStorage.setItem("KycReminderDismissed", "1"); //popup will show only once for broweser.. and will never popup again till key is removed from local storage
      sessionStorage.setItem("KycReminderDismissed", "1");
    },
    handleKycReminderExpiredClose() {
      this.showKycReminderExpired = false;
      //localStorage.setItem("KycReminderDismissed", "1"); //popup will show only once for broweser.. and will never popup again till key is removed from local storage
      sessionStorage.setItem("KycReminderExpiredDismissed", "1");
    },

    //BR#103 - Mbeng 14/07/2025 SwapFreePopup for list of trading accounts group

    checkGroupEligibility(accounts) {
      fetch("/group_names.json")
        .then((res) => res.json())
        .then((data) => {
          const knownGroups = data.group_names || [];

          const userGroups = accounts.map((acc) =>
            acc.group_name ? acc.group_name.replace(/^.*\\/, "") : null
          );

          //console.log("👤 User's trading account groups:", userGroups);
          //console.log("📂 Loaded group_names.json:", knownGroups);

          const now = new Date();
          const startDate = new Date("2025-07-25");
          const endDate = new Date("2025-08-08");
          const inRange = now >= startDate && now <= endDate;

          // Check if any of the user's groups are in the known list
          const matchedGroups = userGroups.filter((g) => knownGroups.includes(g));
          const hasMatch = matchedGroups.length > 0;

          const hasActiveAccount = accounts.some(
            (acc) => acc.status === "active"
          );

          if (!hasMatch && userGroups.some(g => g)) {
            // 👤 Group exists but is not in the allowed list
           // console.log("❌ User has a group, but no match found in allowed list.");
            this.showSwapFreePopup = false;
            this.profileLoaded = true;
          } else if (hasMatch && hasActiveAccount && inRange) {
            // ✅ Show the popup
            this.showSwapFreePopup = true;
           // console.log("✅ Valid group found & account active & within date → Show popup");
          } else {
            // 🔒 All other cases: hide
            this.showSwapFreePopup = false;
            if (!hasActiveAccount) //console.log("⚠️ No active trading account.");
            if (!inRange) //console.log("📅 Not within popup date range.");
            console.log("Popup will NOT be shown.");
          }
        })
        .catch((err) => {
          console.error("Error loading group_names.json:", err);
          this.showSwapFreePopup = false;
        });
    },
    checkAsset(name) {
      try {
        return require(`../../assets/${name}-tab-icon.png`);
      } catch (e) {
        return require(`../../assets/logo-placeholder.png`);
      }
    },
    closeGccPopup() {
      this.showGccDemoPopup = false;
      this.$store.commit("SET_GCC_DEMO_POPUP", false);
    },
    continueGccPopup() {
      this.showGccDemoPopup = false;
      this.$store.commit("SET_GCC_DEMO_POPUP", false);
      this.$router.push("/open-live-account");
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    clearInterval(this.accountDataIntervalId);
  },

   // #BR#74 - Mbeng Atemson - Become a Broker Request  - 09/04/2025
   async sendBrokerRequest(data) {
      try {
        await fetch("/api/accounts/become-broker/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        alert("Your request has been submitted!");
      } catch (error) {
        console.error("Error submitting broker request:", error);
        alert("Something went wrong. Please try again.");
      }
  },
};
</script>
